export default "__VITE_ASSET__0232c884__"